var map = {
	"./virgin-dark.png": 787,
	"./virgin.png": 788
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;


//////////////////
// WEBPACK FOOTER
// ./src/components/AirlineLogo/images/logos ^\.\/virgin.*\.png$
// module id = 786
// module chunks = 0